module.exports = __webpack_public_path__ + "img/HR70663193635.271adb23.png";